const MEASUREMENT_ID = "G-96LVHN91NY";
const CONSENT_KEY = "gameplat_analytics_consent";

let loading;

export function analyticsConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function resetAnalyticsConsent() {
  try {
    window.localStorage.removeItem(CONSENT_KEY);
  } catch {}
}

export function setAnalyticsConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value ? "granted" : "denied");
  } catch {}
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function loadAnalytics() {
  if (analyticsConsent() !== "granted") return Promise.resolve(false);
  if (window.gtag) return Promise.resolve(true);
  if (loading) return loading;

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  loading = new Promise((resolve) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
  return loading;
}

export async function trackPageView(path) {
  if (!(await loadAnalytics())) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export async function trackEvent(name, parameters = {}) {
  if (!(await loadAnalytics())) return;
  window.gtag("event", name, parameters);
}
